import { createElement } from "react";
import type { AppRoute } from "@routes/types";
import AppShellLayout from "@components/ui/layout/AppShellLayout";
import type { RouteObject } from "react-router-dom";
import { ASSESSMENT_PATH } from "@routes/path";
import AssesmentPage from "@pages/assesment";

const routes: AppRoute[] = [
    {
        path: ASSESSMENT_PATH,
        element: createElement(AssesmentPage),
        label: "Assessment",
    },
];

const AssesmentRoute: RouteObject[] = [{
                element: createElement(AppShellLayout),
                children: routes
            }];

export default AssesmentRoute;